module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="hotelTour__rooms js-open-tour-info-dg">\n	';

	if(photos && photos.length) {
		var lengthPhoto = photos.length > 2 ? 2 : photos.length;
		for(var i = 0; i < lengthPhoto; i++) { 
__p+='\n			<div class="hotelTour__room"><img src="'+
((__t=( imageProxy(photos[i],{width:102,height:74}) ))==null?'':__t)+
'" ></div>\n		';
 }
		if(photos.length > lengthPhoto) { 
__p+='\n			<div class="hotelTour__room">\n				<img src="'+
((__t=( imageProxy(photos[lengthPhoto],{width:102,height:74}) ))==null?'':__t)+
'" >\n				<div class="hotelTour__room-more"><span>Еще '+
((__t=( photos.length - lengthPhoto ))==null?'':__t)+
'<br>фото</span></div>\n			</div>\n		';
 } 
__p+='\n	';
 } 
__p+='\n</div>';
}
return __p;
};
